import { useEffect, useState } from "react";
import React from "react";
import Dashboard from "./dashboard/Dashboard";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";
import "./style.css";
import Sidebar2 from "../components/sidebar/Sidebar2";
import AllUsers from "./all-users/AllUsers";
import EditUser from "./all-users/EditUser";
import AllPackages from "./packages/AllPackages";
import EditPackage from "./packages/EditPackage";
import AllHybridPackages from "./hybrid-packages/AllHybridPackages";
import AllHybridWithdrawals from "./hybrid-withdrawals/AllHybridWithdrawals";
import AllHybridBalanceWithdrawals from "./hybrid-balance-withdrawals/AllHybridBalanceWithdrawals";
import AllHybridBonusWithdrawals from "./hybrid-bonus-withdrawals/AllHybridBonusWithdrawals";
import AllMatrixWithdrawals from "./matrix-withdrawals/AllMatrixWithdrawals";
import USDTWithdrawal from "./withdrawal/USDTWithdrawal";
import USDTWithdrawHistory from "./withdrawal/USDTWithdawalHistory";
import GeneratePins from "./pins/GeneratePins";

function Admin() {
  const [isSidebar, setIsSidebar] = useState(window.innerWidth > 768);
  const userType = localStorage.getItem("userType") || "Admin";

  const isAdminOnly = (requiredRole) => {
    if (requiredRole === "All") return true;
    return userType === requiredRole;
  };

  return (
    <div className="mm-left">
      {isSidebar && (
        <div
          className="admin-bg"
          onClick={() => setIsSidebar((prev) => !prev)}
        ></div>
      )}
      <Sidebar setIsSidebar={setIsSidebar} isSidebar={isSidebar} />

      <div className="admin-main-body">
        <Sidebar2 isSidebar={isSidebar} setIsSidebar={setIsSidebar} />
        <div className="admin-left">
          <Routes>
            {isAdminOnly("Admin") && <Route path="/dashboard" element={<Dashboard />} />}
            {isAdminOnly("Admin") && <Route path="/all-users" element={<AllUsers />} />}
            <Route path="/edit-users" element={<EditUser />} />
            {isAdminOnly("Admin") && <Route path="/get-all-package" element={<AllPackages />} />}
            {isAdminOnly("Admin") && <Route path="/edit-package" element={<EditPackage />} />}
            {isAdminOnly("Admin") && <Route path="/all-hybrid-packages" element={<AllHybridPackages />} />}
            {isAdminOnly("Admin") && <Route path="/generate-pins" element={<GeneratePins />} />}
            {isAdminOnly("Admin") && <Route path="/all-hybrid-withdrawals" element={<AllHybridWithdrawals />} />}
            {isAdminOnly("Admin") && <Route path="/all-hybrid-balance-withdrawals" element={<AllHybridBalanceWithdrawals />} />}
            {isAdminOnly("Admin") && <Route path="/all-hybrid-bonus-withdrawals" element={<AllHybridBonusWithdrawals />} />}
            {isAdminOnly("Admin") && <Route path="/all-matrix-withdrawals" element={<AllMatrixWithdrawals />} />}
            {isAdminOnly("Admin") && <Route path="/usdt-withdrawal" element={<USDTWithdrawal />} />}
            {isAdminOnly("Admin") && <Route path="/usdt-withdrawal-history" element={<USDTWithdrawHistory />} />}
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default Admin;
